import { useMediaMatches } from '@frontend/responsiveness';
import { Modal, ModalProps } from '@frontend/design-system';

type CommonModalProps = ModalProps & {
  children: React.ReactNode;
};

export const CommonModalWrapper = ({ children, ...rest }: CommonModalProps) => {
  const { matches } = useMediaMatches();
  const mediumMin = matches.useMediumMin();
  const minWidth = mediumMin ? 600 : 300;
  return (
    <Modal minWidth={minWidth} {...rest}>
      {children}
    </Modal>
  );
};
